
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as ReportsNT0FtPXF1XMeta } from "/Users/jorgemariogonzalez/Proyectos/Snapei/t2t-front/pages/admin/Reports.vue?macro=true";
import { default as indexkq59W7sC3rMeta } from "/Users/jorgemariogonzalez/Proyectos/Snapei/t2t-front/pages/apps/contacts/index.vue?macro=true";
import { default as CheckoutSG4loREURnMeta } from "/Users/jorgemariogonzalez/Proyectos/Snapei/t2t-front/pages/apps/ecommerce/Checkout.vue?macro=true";
import { default as checkoutMixinCU6eq38F5bMeta } from "/Users/jorgemariogonzalez/Proyectos/Snapei/t2t-front/pages/apps/ecommerce/checkoutMixin.ts?macro=true";
import { default as _91id_93lEJXb8iwAUMeta } from "/Users/jorgemariogonzalez/Proyectos/Snapei/t2t-front/pages/apps/ecommerce/product/detail/[id].vue?macro=true";
import { default as ProductListAXiqBp0GyjMeta } from "/Users/jorgemariogonzalez/Proyectos/Snapei/t2t-front/pages/apps/ecommerce/ProductList.vue?macro=true";
import { default as ProductsfcDHbibFqPMeta } from "/Users/jorgemariogonzalez/Proyectos/Snapei/t2t-front/pages/apps/ecommerce/Products.vue?macro=true";
import { default as indexkbYMrgZX08Meta } from "/Users/jorgemariogonzalez/Proyectos/Snapei/t2t-front/pages/apps/maps/index.vue?macro=true";
import { default as indexLkP52mP86AMeta } from "/Users/jorgemariogonzalez/Proyectos/Snapei/t2t-front/pages/apps/notes/index.vue?macro=true";
import { default as Loginb6hWY55xUbMeta } from "/Users/jorgemariogonzalez/Proyectos/Snapei/t2t-front/pages/auth/Login.vue?macro=true";
import { default as Register5Rn6qACx2gMeta } from "/Users/jorgemariogonzalez/Proyectos/Snapei/t2t-front/pages/auth/Register.vue?macro=true";
import { default as Reset_45Password2BcioByiaYMeta } from "/Users/jorgemariogonzalez/Proyectos/Snapei/t2t-front/pages/auth/Reset-Password.vue?macro=true";
import { default as _91uuid_93iXA9BXIcRtMeta } from "/Users/jorgemariogonzalez/Proyectos/Snapei/t2t-front/pages/auth/reset-password/[uuid].vue?macro=true";
import { default as delete_45accountixVqFvjBdsMeta } from "/Users/jorgemariogonzalez/Proyectos/Snapei/t2t-front/pages/help/delete-account.vue?macro=true";
import { default as indexJXKxytpta0Meta } from "/Users/jorgemariogonzalez/Proyectos/Snapei/t2t-front/pages/index.vue?macro=true";
import { default as logoutl6J5a1RVXcMeta } from "/Users/jorgemariogonzalez/Proyectos/Snapei/t2t-front/pages/logout.vue?macro=true";
import { default as AsignacionesTnRpdi5BmSMeta } from "/Users/jorgemariogonzalez/Proyectos/Snapei/t2t-front/pages/tat/admin/Asignaciones.vue?macro=true";
import { default as CentrosOperativosOufm86I9oKMeta } from "/Users/jorgemariogonzalez/Proyectos/Snapei/t2t-front/pages/tat/admin/CentrosOperativos.vue?macro=true";
import { default as Dashboardhi6Li2EdvTMeta } from "/Users/jorgemariogonzalez/Proyectos/Snapei/t2t-front/pages/tat/admin/Dashboard.vue?macro=true";
import { default as PedidosBtXPxr9kRzMeta } from "/Users/jorgemariogonzalez/Proyectos/Snapei/t2t-front/pages/tat/admin/Pedidos.vue?macro=true";
import { default as Historial6U2Kwt5kxXMeta } from "/Users/jorgemariogonzalez/Proyectos/Snapei/t2t-front/pages/tat/picker/Historial.vue?macro=true";
import { default as _91id_93FpSXM6M52YMeta } from "/Users/jorgemariogonzalez/Proyectos/Snapei/t2t-front/pages/tat/picker/Pedido/[id].vue?macro=true";
import { default as PedidosVgOVdraXk7Meta } from "/Users/jorgemariogonzalez/Proyectos/Snapei/t2t-front/pages/tat/picker/Pedidos.vue?macro=true";
import { default as PedidosLhWUXhRQKOMeta } from "/Users/jorgemariogonzalez/Proyectos/Snapei/t2t-front/pages/tat/transportista/Pedidos.vue?macro=true";
import { default as ClientesqGJJi22n76Meta } from "/Users/jorgemariogonzalez/Proyectos/Snapei/t2t-front/pages/tat/vendedor/Clientes.vue?macro=true";
import { default as Pedidog7Ug6sS3dLMeta } from "/Users/jorgemariogonzalez/Proyectos/Snapei/t2t-front/pages/tat/vendedor/Pedido.vue?macro=true";
import { default as Pedidosh0W23PSC8QMeta } from "/Users/jorgemariogonzalez/Proyectos/Snapei/t2t-front/pages/tat/vendedor/Pedidos.vue?macro=true";
import { default as RutavzGI5SyGImMeta } from "/Users/jorgemariogonzalez/Proyectos/Snapei/t2t-front/pages/tat/vendedor/Ruta.vue?macro=true";
import { default as Userss2nv55FckvMeta } from "/Users/jorgemariogonzalez/Proyectos/Snapei/t2t-front/pages/tests/Users.vue?macro=true";
import { default as MyProfileC7qIJXvuYSMeta } from "/Users/jorgemariogonzalez/Proyectos/Snapei/t2t-front/pages/user/MyProfile.vue?macro=true";
import { default as MyPurchasespMN4v7jrMaMeta } from "/Users/jorgemariogonzalez/Proyectos/Snapei/t2t-front/pages/user/MyPurchases.vue?macro=true";
export default [
  {
    name: "admin-Reports",
    path: "/admin/Reports",
    component: () => import("/Users/jorgemariogonzalez/Proyectos/Snapei/t2t-front/pages/admin/Reports.vue")
  },
  {
    name: "apps-contacts",
    path: "/apps/contacts",
    component: () => import("/Users/jorgemariogonzalez/Proyectos/Snapei/t2t-front/pages/apps/contacts/index.vue")
  },
  {
    name: "apps-ecommerce-Checkout",
    path: "/apps/ecommerce/Checkout",
    component: () => import("/Users/jorgemariogonzalez/Proyectos/Snapei/t2t-front/pages/apps/ecommerce/Checkout.vue")
  },
  {
    name: "apps-ecommerce-checkoutMixin",
    path: "/apps/ecommerce/checkoutMixin",
    component: () => import("/Users/jorgemariogonzalez/Proyectos/Snapei/t2t-front/pages/apps/ecommerce/checkoutMixin.ts")
  },
  {
    name: "apps-ecommerce-product-detail-id",
    path: "/apps/ecommerce/product/detail/:id()",
    component: () => import("/Users/jorgemariogonzalez/Proyectos/Snapei/t2t-front/pages/apps/ecommerce/product/detail/[id].vue")
  },
  {
    name: "apps-ecommerce-ProductList",
    path: "/apps/ecommerce/ProductList",
    component: () => import("/Users/jorgemariogonzalez/Proyectos/Snapei/t2t-front/pages/apps/ecommerce/ProductList.vue")
  },
  {
    name: "apps-ecommerce-Products",
    path: "/apps/ecommerce/Products",
    component: () => import("/Users/jorgemariogonzalez/Proyectos/Snapei/t2t-front/pages/apps/ecommerce/Products.vue")
  },
  {
    name: "apps-maps",
    path: "/apps/maps",
    component: () => import("/Users/jorgemariogonzalez/Proyectos/Snapei/t2t-front/pages/apps/maps/index.vue")
  },
  {
    name: "apps-notes",
    path: "/apps/notes",
    component: () => import("/Users/jorgemariogonzalez/Proyectos/Snapei/t2t-front/pages/apps/notes/index.vue")
  },
  {
    name: "auth-Login",
    path: "/auth/Login",
    meta: Loginb6hWY55xUbMeta || {},
    component: () => import("/Users/jorgemariogonzalez/Proyectos/Snapei/t2t-front/pages/auth/Login.vue")
  },
  {
    name: "auth-Register",
    path: "/auth/Register",
    meta: Register5Rn6qACx2gMeta || {},
    component: () => import("/Users/jorgemariogonzalez/Proyectos/Snapei/t2t-front/pages/auth/Register.vue")
  },
  {
    name: "auth-Reset-Password",
    path: "/auth/Reset-Password",
    meta: Reset_45Password2BcioByiaYMeta || {},
    component: () => import("/Users/jorgemariogonzalez/Proyectos/Snapei/t2t-front/pages/auth/Reset-Password.vue")
  },
  {
    name: "auth-reset-password-uuid",
    path: "/auth/reset-password/:uuid()",
    meta: _91uuid_93iXA9BXIcRtMeta || {},
    component: () => import("/Users/jorgemariogonzalez/Proyectos/Snapei/t2t-front/pages/auth/reset-password/[uuid].vue")
  },
  {
    name: "help-delete-account",
    path: "/help/delete-account",
    meta: delete_45accountixVqFvjBdsMeta || {},
    component: () => import("/Users/jorgemariogonzalez/Proyectos/Snapei/t2t-front/pages/help/delete-account.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexJXKxytpta0Meta || {},
    component: () => import("/Users/jorgemariogonzalez/Proyectos/Snapei/t2t-front/pages/index.vue")
  },
  {
    name: "logout",
    path: "/logout",
    meta: logoutl6J5a1RVXcMeta || {},
    component: () => import("/Users/jorgemariogonzalez/Proyectos/Snapei/t2t-front/pages/logout.vue")
  },
  {
    name: "tat-admin-Asignaciones",
    path: "/tat/admin/Asignaciones",
    meta: AsignacionesTnRpdi5BmSMeta || {},
    component: () => import("/Users/jorgemariogonzalez/Proyectos/Snapei/t2t-front/pages/tat/admin/Asignaciones.vue")
  },
  {
    name: "tat-admin-CentrosOperativos",
    path: "/tat/admin/CentrosOperativos",
    meta: CentrosOperativosOufm86I9oKMeta || {},
    component: () => import("/Users/jorgemariogonzalez/Proyectos/Snapei/t2t-front/pages/tat/admin/CentrosOperativos.vue")
  },
  {
    name: "tat-admin-Dashboard",
    path: "/tat/admin/Dashboard",
    meta: Dashboardhi6Li2EdvTMeta || {},
    component: () => import("/Users/jorgemariogonzalez/Proyectos/Snapei/t2t-front/pages/tat/admin/Dashboard.vue")
  },
  {
    name: "tat-admin-Pedidos",
    path: "/tat/admin/Pedidos",
    meta: PedidosBtXPxr9kRzMeta || {},
    component: () => import("/Users/jorgemariogonzalez/Proyectos/Snapei/t2t-front/pages/tat/admin/Pedidos.vue")
  },
  {
    name: "tat-picker-Historial",
    path: "/tat/picker/Historial",
    meta: Historial6U2Kwt5kxXMeta || {},
    component: () => import("/Users/jorgemariogonzalez/Proyectos/Snapei/t2t-front/pages/tat/picker/Historial.vue")
  },
  {
    name: "tat-picker-Pedido-id",
    path: "/tat/picker/Pedido/:id()",
    meta: _91id_93FpSXM6M52YMeta || {},
    component: () => import("/Users/jorgemariogonzalez/Proyectos/Snapei/t2t-front/pages/tat/picker/Pedido/[id].vue")
  },
  {
    name: "tat-picker-Pedidos",
    path: "/tat/picker/Pedidos",
    meta: PedidosVgOVdraXk7Meta || {},
    component: () => import("/Users/jorgemariogonzalez/Proyectos/Snapei/t2t-front/pages/tat/picker/Pedidos.vue")
  },
  {
    name: "tat-transportista-Pedidos",
    path: "/tat/transportista/Pedidos",
    meta: PedidosLhWUXhRQKOMeta || {},
    component: () => import("/Users/jorgemariogonzalez/Proyectos/Snapei/t2t-front/pages/tat/transportista/Pedidos.vue")
  },
  {
    name: "tat-vendedor-Clientes",
    path: "/tat/vendedor/Clientes",
    meta: ClientesqGJJi22n76Meta || {},
    component: () => import("/Users/jorgemariogonzalez/Proyectos/Snapei/t2t-front/pages/tat/vendedor/Clientes.vue")
  },
  {
    name: "tat-vendedor-Pedido",
    path: "/tat/vendedor/Pedido",
    meta: Pedidog7Ug6sS3dLMeta || {},
    component: () => import("/Users/jorgemariogonzalez/Proyectos/Snapei/t2t-front/pages/tat/vendedor/Pedido.vue")
  },
  {
    name: "tat-vendedor-Pedidos",
    path: "/tat/vendedor/Pedidos",
    meta: Pedidosh0W23PSC8QMeta || {},
    component: () => import("/Users/jorgemariogonzalez/Proyectos/Snapei/t2t-front/pages/tat/vendedor/Pedidos.vue")
  },
  {
    name: "tat-vendedor-Ruta",
    path: "/tat/vendedor/Ruta",
    meta: RutavzGI5SyGImMeta || {},
    component: () => import("/Users/jorgemariogonzalez/Proyectos/Snapei/t2t-front/pages/tat/vendedor/Ruta.vue")
  },
  {
    name: "tests-Users",
    path: "/tests/Users",
    component: () => import("/Users/jorgemariogonzalez/Proyectos/Snapei/t2t-front/pages/tests/Users.vue")
  },
  {
    name: "user-MyProfile",
    path: "/user/MyProfile",
    component: () => import("/Users/jorgemariogonzalez/Proyectos/Snapei/t2t-front/pages/user/MyProfile.vue")
  },
  {
    name: "user-MyPurchases",
    path: "/user/MyPurchases",
    component: () => import("/Users/jorgemariogonzalez/Proyectos/Snapei/t2t-front/pages/user/MyPurchases.vue")
  }
]